import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { NavigationIds } from "components/v2/shared-navigation/SharedNavigation";
import { getActiveTab, getCurrentUserId, getNhDealApplicationId } from "features/authSlice";
import { selectIsUqualAdBannerDismissed, setUqualAdBannerDismissed } from "features/uqualAdBannerSlice";
import { useUqualVisibilityFlags } from "hooks/useUqualVisibilityFlags";
import { UQUAL_AD_BANNER_DISMISS_KEY } from "utilities/Constant";

export const useUqualAdBannerVisibility = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const userId = useSelector(getCurrentUserId);
  const activeTab = useSelector(getActiveTab);
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const bannerDismissed = useSelector(selectIsUqualAdBannerDismissed);

  const isOnDashboardHome = useMemo(() => {
    const onDashboardRoot = pathname === "/dashboard" || pathname === "/dashboard/";
    const isHomeTab = activeTab === "" || activeTab === NavigationIds.Home;
    return onDashboardRoot && isHomeTab;
  }, [pathname, activeTab]);

  const { showUqualBanner } = useUqualVisibilityFlags({
    skipQuery: !isOnDashboardHome || !nhDealApplicationId || !userId,
  });

  const isEligible = showUqualBanner;

  const isBannerVisible = useMemo(
    () => Boolean(nhDealApplicationId && userId && isOnDashboardHome && isEligible && !bannerDismissed),
    [nhDealApplicationId, userId, isOnDashboardHome, isEligible, bannerDismissed],
  );

  const dismissBanner = useCallback(() => {
    sessionStorage.setItem(UQUAL_AD_BANNER_DISMISS_KEY, "true");
    dispatch(setUqualAdBannerDismissed(true));
  }, [dispatch]);

  return { isBannerVisible, dismissBanner };
};
